export const FORMATTING_STATUS_IN_PROGRESS = "IN_PROGRESS"
export const FORMATTING_STATUS_ERROR = "ERROR"
export const FORMATTING_STATUS_UNKNOWN = "UNKNOWN"
export const FORMATTING_STATUS_COMPLETE = "COMPLETE"